import { Link } from "react-router-dom";

/**
 * Slim seasonal announcement strip for Swami ji's USA visit. Renders nothing
 * unless the announcement is enabled. Single constant-height row (dates/cities
 * hidden on mobile so it never wraps — keeps the Layout spacer height stable).
 */
export default function VisitStrip({ announcement }) {
  if (!announcement?.enabled) return null;
  const headline = announcement.headline || "Swami ji is visiting";
  const meta = [announcement.dateRange, announcement.citiesLine].filter(Boolean).join(" · ");
  const ctaLabel = announcement.ctaLabel || "Schedule a Visit";

  return (
    <div className="relative flex h-10 w-full items-center justify-center gap-x-3 overflow-hidden bg-[#2a120d] px-4 text-center text-white">
      <span className="absolute left-0 top-0 h-full w-1 bg-[#f5c45e]" aria-hidden="true" />
      <span className="flex min-w-0 items-center gap-2 text-xs font-semibold sm:text-sm">
        <span
          className="inline-block h-2 w-2 shrink-0 rounded-full bg-[#f5c45e]"
          style={{ animation: "agmVisitPulse 1.8s ease-in-out infinite" }}
          aria-hidden="true"
        />
        <span className="truncate">{headline}</span>
      </span>
      {meta ? (
        <span className="hidden truncate text-xs text-white/80 sm:inline">{meta}</span>
      ) : null}
      <Link
        to="/schedule"
        className="ml-1 inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#f5c45e] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.08em] text-[#201711] transition hover:bg-[#ffd77c]"
      >
        {ctaLabel} →
      </Link>
      <style>{`@keyframes agmVisitPulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.45;transform:scale(.7)}}`}</style>
    </div>
  );
}
